import {
  checkUserHasAdminRole,
  checkUserHasManagerRole,
  checkUserHasClientRole,
  getLandingRoute,
} from "app/services/app.state.service";
import { Navigate } from "react-router-dom";
import { ProjectAdminView } from "app/components/projects/ProjectAdminView";
import { ProjectManagerView } from "app/components/projects/ProjectManagerView";
import { ProjectClientView } from "app/components/projects/ProjectClientView";

export const ProjectRouterFactory = () => {
  if (checkUserHasAdminRole()) {
    return <ProjectAdminView />;
  } else if (checkUserHasManagerRole()) {
    return <ProjectManagerView />;
  } else if (checkUserHasClientRole()) {
    return <ProjectClientView />;
  } else {
    // Not allowed here — route to the user's landing screen rather than
    // reloading the app, which would blank the screen on slower networks.
    return <Navigate to={getLandingRoute()} replace />;
  }
};

